import { Settings } from "bobjoll/ts/library/settings";
import { delegate, qq, q } from 'bobjoll/ts/library/dom';

const menu = document.getElementById('nav-main');

const eventHandlerClickChild = function(this: HTMLLinkElement, event: TouchEvent) {
    qq('.menu-item-has-children > a').forEach(link => {
        if (this !== link) {
            link.classList.remove('show');
        }
    });

    if ( window.innerWidth <= Settings.breakpoints.lg ) {
        this.classList.toggle('show');
        event.preventDefault();
    }
}

const eventHandlerResize = function() {
    if (menu) {
        if ( window.innerWidth > Settings.breakpoints.lg || menu.classList.contains('nav--mobile') ) return;

        menu.classList.add('nav--mobile');

        qq('.menu-item-has-children', menu).forEach(element => {
            const link = q('a', element) as HTMLLinkElement|undefined;
            const list = q('ul', element);

            if (link && list) {
                link.addEventListener('touchend', eventHandlerClickChild);
                list.insertAdjacentHTML('afterbegin', `<li class="menu-item inline-block hide"><a href="${link.href}">View all</a></li>`);
            }
        });
    }
}

eventHandlerResize();

window.onresize = eventHandlerResize;